module.exports = __webpack_public_path__ + "static/media/Knob5.3bd08b53.png";